import { useEffect, useState } from "react";
import "./Disclaimer.css"

const messages = [
    "⚠️ Use only in real emergency situations",
    "🔒 Respect user privacy. Do not misuse data",
    "🚨 This system is designed to save lives",
    "🙏 Please act responsibly while using this service"
];

function Disclaimer() {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % messages.length);
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    return <div className="disclaimer-fade">{messages[index]}</div>;
}

export default Disclaimer;